import type { Building } from "building-types/building/buildingTypes";
import type { HandleRelation, SpatialHandle } from "building-types/building/graph";
import shallowCompare from "common/utils/shallowCompare";
import { BuildingGenerationContext } from "doc/utils/buildingGenerationContext";
import memo from "../utils/memo";

function select(building: Building) {
  return building;
}

function generate(_: ReturnType<typeof select>): Pick<Building, "entityGraphNodes" | "entityGraphRelationships"> {
  const entityGraphNodes: SpatialHandle[] = [];
  const entityGraphRelationships: HandleRelation[] = [];

  const seen: Set<string> = new Set();

  check: for (const ephemeralHandle of BuildingGenerationContext.indexNodes()) {
    const hash = BuildingGenerationContext.indexNodeHash(ephemeralHandle);
    if (seen.has(hash)) {
      continue;
    }
    seen.add(hash);

    const aabb = BuildingGenerationContext.indexNodeAABB(ephemeralHandle);

    const node: SpatialHandle = {
      handle: ephemeralHandle,
      aabb: aabb,
    };

    entityGraphNodes.push(node);
    for (const relationship of BuildingGenerationContext.indexRelationships(ephemeralHandle)) {
      const ephemeralBHandle = BuildingGenerationContext.indexNodeByHash(relationship.b);
      if (!ephemeralBHandle) {
        continue;
      }
      const bNode: SpatialHandle = {
        handle: ephemeralBHandle,
        aabb: BuildingGenerationContext.indexNodeAABB(ephemeralBHandle),
      };
      entityGraphRelationships.push({
        a: node,
        b: bNode,
        type: relationship.type,
      });
    }
  }

  return {
    entityGraphNodes,
    entityGraphRelationships,
  };
}

export default memo(select, generate, shallowCompare);
